export enum ModuleName {
  Products = 'Products',
  Subscriptions = 'Subscriptions',
  BillingHistory = 'Billing History',
  PaymentMethods = 'Payment Methods',
  Integrations = 'Integrations',
  Cart = 'Cart',
}
